// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__aqTBm","title":"style_title__2mHEv","editButtonWrapper":"style_editButtonWrapper__2yJx8"};